// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class DesignSystemVersionStats {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.tokens = model.tokens;
        this.designSystemComponents = model.designSystemComponents;
        this.assets = model.assets;
        this.documentationPages = model.documentationPages;
        this.figmaComponents = model.figmaComponents;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        return {
            tokens: this.tokens,
            designSystemComponents: this.designSystemComponents,
            assets: this.assets,
            documentationPages: this.documentationPages,
            figmaComponents: this.figmaComponents,
        };
    }
}
